import { B2Card, B2Col, B2Row } from "@hdb/biome-2";
import { FC } from "react";
import { Spinner } from "react-bootstrap";
import db_bulb_off from "../../../../src/assets/images/db-bulb-off.png";
import db_bulb_on from "../../../../src/assets/images/db-bulb-on.png";
import db_gateway from "../../../../src/assets/images/db-gateway.png";
import db_light_bulb from "../../../../src/assets/images/db-light-bulb.png";
import db_wifi_disable from "../../../../src/assets/images/db-wifi-disable.png";
import db_wifi_enable from "../../../../src/assets/images/db-wifi-enable.png";
import db_group from "../../../../src/assets/images/db_group.png";

interface TCStatisticsComponentType {
  lightLocationDashboardSummary: any;
  isLoadingLightLocationDashboardSummary: boolean;
  isLoadingLocationBlockSummary: boolean;
  locationBlockSummary: any;
  isLoadingLocationGatewaySummary: boolean;
  locationGatewaySummary: any;
  isLoadingLocationLightSummary: boolean;
  locationLightSummary: any;
}

const TCStatisticsComponent: FC<TCStatisticsComponentType> = ({
  lightLocationDashboardSummary,
  isLoadingLightLocationDashboardSummary,
  isLoadingLocationBlockSummary,
  locationBlockSummary,
  isLoadingLocationGatewaySummary,
  locationGatewaySummary,
  isLoadingLocationLightSummary,
  locationLightSummary,
}) => {
  return (
    <B2Col xs={12} lg={6} className="mb-3 mb-lg-0 px-lg-2">
      <B2Card className="p-3">
        <B2Row className="d-flex align-items-center">
          {/* Blocks Section */}
          <h4 className="fw-bold mb-3 text-center d-block d-sm-none">
            Town Council Overview
          </h4>
          <B2Col xs={12} md={4} className="d-md-flex justify-content-between">
            <div className="d-flex flex-column align-items-center justify-content-center text-center text-md-start mb-5 mb-sm-0">
              <div className="d-flex gap-4">
                <div className="mt-1">
                  <img
                    style={{ height: "60px" }}
                    src={db_group}
                    alt="db_group"
                  />
                </div>

                <div className="d-flex flex-column">
                  {isLoadingLightLocationDashboardSummary ? (
                    <Spinner
                      animation="border"
                      variant="secondary"
                      className="mt-1"
                    />
                  ) : (
                    <h1 className="m-0 textNeutral600 fw-bold">
                      {lightLocationDashboardSummary?.totalBlock || 0}
                    </h1>
                  )}

                  <p className="m-0 textNeutral600 fw-medium">Blocks</p>
                </div>
              </div>
              <div className="mt-3 w-100 text-center">
                <h5 className="textDanger700 fw-bold m-0">
                  Faults
                  {isLoadingLocationBlockSummary ? (
                    <Spinner
                      animation="border"
                      variant="danger"
                      size="sm"
                      className="ms-2"
                    />
                  ) : (
                    <span className="ms-2 fw-semibold">
                      {locationBlockSummary?.totalFaultyBlock || 0}
                    </span>
                  )}
                </h5>
              </div>
            </div>

            <div className="vertical-dashed-line d-none d-md-block"></div>
          </B2Col>

          {/* Gateways Section */}
          <B2Col xs={12} md={4} className="d-md-flex justify-content-between">
            <div className="d-flex flex-column align-items-center justify-content-center text-center text-md-start mb-5 mb-sm-0">
              <div className="d-flex gap-4">
                <div className="mt-1">
                  <img
                    className="object-fit-contain"
                    src={db_gateway}
                    alt="db_gateway"
                  />
                </div>

                <div className="d-flex flex-column">
                  {isLoadingLightLocationDashboardSummary ? (
                    <Spinner
                      animation="border"
                      variant="secondary"
                      className="mt-1"
                    />
                  ) : (
                    <h1 className="m-0 textNeutral600 fw-bold">
                      {lightLocationDashboardSummary?.totalGateway || 0}
                    </h1>
                  )}

                  <p className="m-0 textNeutral600 fw-medium">Gateways</p>
                </div>
              </div>

              <div className="d-flex gap-5 align-items-center mt-3 w-100 justify-content-center">
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <img
                    src={db_wifi_enable}
                    alt="db_wifi_enable"
                    title="Online"
                  />
                  {isLoadingLocationGatewaySummary ? (
                    <Spinner
                      animation="border"
                      variant="success"
                      size="sm"
                      className="mt-1"
                    />
                  ) : (
                    <h5 className="m-0 textSuccess700 fw-bold">
                      {locationGatewaySummary?.totalOnlineGateway || 0}
                    </h5>
                  )}
                </div>
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <img
                    src={db_wifi_disable}
                    alt="db_wifi_disable"
                    title="Offline"
                  />
                  {isLoadingLocationGatewaySummary ? (
                    <Spinner
                      animation="border"
                      variant="secondary"
                      size="sm"
                      className="mt-1"
                    />
                  ) : (
                    <h5 className="m-0 textNeutral600">
                      {locationGatewaySummary?.totalOfflineGateway || 0}
                    </h5>
                  )}
                </div>
              </div>
            </div>

            <div className="vertical-dashed-line d-none d-md-block"></div>
          </B2Col>

          {/* Lights Section */}
          <B2Col
            xs={12}
            md={4}
            className="d-flex flex-column align-items-center align-items-lg-start justify-content-center text-center text-md-start mb-5 mb-sm-0"
          >
            <div className="d-flex gap-4">
              <div className="mt-1">
                <img
                  className="object-fit-contain"
                  src={db_light_bulb}
                  alt="db_light_bulb"
                />
              </div>

              <div className="d-flex flex-column">
                {isLoadingLightLocationDashboardSummary ? (
                  <Spinner
                    animation="border"
                    variant="secondary"
                    className="mt-1"
                  />
                ) : (
                  <h1 className="m-0 textNeutral600 fw-bold">
                    {lightLocationDashboardSummary?.totalLight || 0}
                  </h1>
                )}

                <p className="m-0 textNeutral600 fw-medium">Lights</p>
              </div>
            </div>

            <div className="d-flex gap-5 align-items-center align-items-center mt-3 w-100 justify-content-center  justify-content-lg-start">
              <div className="d-flex justify-content-center align-items-center gap-2">
                <img src={db_bulb_on} alt="db_bulb_on" title="Light On" />
                {isLoadingLocationLightSummary ? (
                  <Spinner
                    animation="border"
                    variant="success"
                    size="sm"
                    className="mt-1"
                  />
                ) : (
                  <h5 className="m-0 textSuccess700 fw-bold">
                    {locationLightSummary?.totalOnlineLight || 0}
                  </h5>
                )}
              </div>
              <div className="d-flex justify-content-center align-items-center gap-2">
                <img src={db_bulb_off} alt="db_bulb_off" title="Light Off" />
                {isLoadingLocationLightSummary ? (
                  <Spinner
                    animation="border"
                    variant="secondary"
                    size="sm"
                    className="mt-1"
                  />
                ) : (
                  <h5 className="m-0 textNeutral600">
                    {locationLightSummary?.totalOfflineLight || 0}
                  </h5>
                )}
              </div>
            </div>
          </B2Col>
        </B2Row>
      </B2Card>
    </B2Col>
  );
};

export default TCStatisticsComponent;
